import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AboutAuth from "../../components/UI/AboutAuth";

import { useStore } from "../../hook-store/store";

// import AboutPageImage1 from "../../images/audio-tools-image-crop-h200.jpg";
// import AboutPageImage2 from "../../images/cloud-sync-crop-h200.png";

import { kuraStorageLink } from '../../App';

import { marks } from "../../utils/marks";
// import './AboutPage.css';

const VideoToAudioAbout = (props) => {

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // },[]);

  return (
    <Fragment>
      <div>
        <p>
          In <strong>Video to Audio,</strong> 
          {' '}
          {t('aboutPage.26', 'audio file is created from video file.')}
          {' '}
          {t('aboutPage.27', 'Audio data are extracted from video file, and audio file is created using the audio data.')}
          {' '}
          {t('aboutPage.28', 'User can download the file or upload the file')} 
          {' '}to{' '}
          <a href={`${kuraStorageLink}/about`}
            target="_blank" rel="noopener noreferrer"
          >
            <strong>Kura Storage</strong>
          </a>. 
          <br/>
          {marks.fileVideoOMark} {`-->`} {marks.fileAudioOMark}
        </p>
        <br/>

        <p>
          In <strong>Convert to MP4</strong> 
          {' '}(in Video to Audio),{' '}
          {t('videoToAudio14', 'user can change video file format to mp4 video file')} 
          {' '}({t('videoToAudio15', 'webm, mov, avi files are accepted')} ).
          <br/>
          {t('videoToAudio16', 'After conversion to mp4 file, user can download or upload the file')} 
          {' '}to{' '}
          <a href={`${kuraStorageLink}/about`}
            target="_blank" rel="noopener noreferrer"
          >
            <strong>Kura Storage</strong>
          </a>. 
          <br/>
          {marks.fileVideoOMark} {marks.exchangeMark} {marks.fileVideoOMark}
        </p>

        {!isAuth && (
          <AboutAuth />
        )}
      </div>
    </Fragment>
  );
};
export default VideoToAudioAbout;
